// extracted by mini-css-extract-plugin
export var body = "D-iOL";
export var card = "_9eMFu";
export var cardContainer = "wkh+-";
export var footer = "_2UzoF";
export var imgBackground = "CBOim";